<template>
    <section>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <img src="/images/Rewards-BC.jpg" style="width:100%;height:auto">
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
    export default {
        data(){
            return{

            };
        },
        methods:{

        },
        computed: {

        },
        created(){
            // console.log(this.$_.range(1, 3));
            // this.$toast.fire({ icon: 'error', title: "Some Error" });
        },
        mounted() {
            
        }
    }
</script>
